<template>
    <section class="want-design section">
        <div class="container">
            <div class="want-design__inner">
                <h2 class="title">Сделайте ваш дом или бизнес уютнее</h2>
                <p class="want-design__text">
                    Запросите создание проекта для вашей квартиры, дома, кафе, ресторана или магазина. Наши дизайнеры
                    создадут выразительный дизайн-проект под ваши задачи.
                </p>
                <button class="btn" type="button" @click="openForm">Хочу дизайн проект</button>
            </div>
            <img class="want-design__img lazy" data-src="/assets/img/index/design-project.png" alt="ролатекс фото">
        </div>
    </section>
</template>

<script>
import designForm from "./modals/design-form";

export default {
    name: 'wantDesign',
    components: {designForm},

    methods: {
        openForm() {
            this.$store.commit('setOverlayStatus', true);
            this.$store.commit('setModalStatus', true);
            this.$store.commit('setDesignFormStatus', true);
            document.body.classList.add('_no-scroll');
        }
    },
}
</script>
